import { asset, pages } from '../data/content'

export default function About() {
  const { instagram, instagramLabel } = pages.about

  return (
    <main className="py-[clamp(20px,3vw,36px)]">
      <img
        data-reveal
        src={asset('2022/01/Hello-Im-Sky.jpg')}
        alt="Hello, I'm Sky"
        className="mx-auto mb-7 block h-auto w-4/5"
      />

      <section className="grid grid-cols-1 items-center gap-8 lg:grid-cols-[minmax(0,1.2fr)_minmax(0,0.8fr)] lg:gap-12">
        <div data-reveal className="flex max-w-[62ch] flex-col gap-3">
          <p className="text-caps m-0 text-rose">The founder</p>
          <h1 className="text-caps-hero m-0 text-balance text-ink">About Sky</h1>
          <p className="m-0 leading-relaxed text-copy">
            Fashion blogs have always been my favorite thing to read. I’m subscribed to all the magazines. My tabs
            are permanently full of articles about Bella Hadid, a new restaurant opening, or some obscure skincare
            product I absolutely do not need but suddenly can’t stop thinking about. I eat that stuff up.
          </p>
          <p className="m-0 leading-relaxed text-copy">
            But I was always disappointed when I opened a lot of fashion sites. Instead of getting the scoop on the
            things people were actually talking about, I felt like I was being assigned homework. Everything was
            either impossibly expensive, impossibly serious, or written for someone living a completely different
            life.
          </p>
          <p className="text-caps-h3 m-0 text-ink">In this economy, the devil wears Zara.</p>
          <p className="m-0 leading-relaxed text-copy">
            So I kept scrolling, looking for something that felt fun. Something that could tell me where to get the
            best matcha, what brands were worth buying, which trends were actually happening, and what cool girls
            were quietly obsessed with before everyone else caught on. I wanted a place that could talk about Kate
            Moss and internet culture in the same breath — a vintage leather jacket, a niche hotel, a perfect bagel,
            or the outfit someone wore to grab coffee. And when I couldn’t find it, I made it.
          </p>
          <p className="m-0 leading-relaxed text-copy">
            The It Girl Guide is part fashion blog, part culture magazine, part group chat. It’s where I share what
            I’m wearing, buying, bookmarking, reading, eating, and thinking about — shopping guides, trend reports,
            travel recommendations, beauty finds, internet rabbit holes, and all the little things that make life
            feel more interesting.
          </p>
          <p className="m-0 leading-relaxed text-copy">
            Despite the name, I don’t think being an It Girl has much to do with money, fame, or being born into the
            right family. The most interesting women usually have something else entirely: curiosity, taste,
            confidence, and a point of view. That’s what TIGG is really about — finding your people, developing your
            taste, paying attention to culture, and creating a life that feels distinctly your own. And sometimes
            it’s just about discussing an iconic celebrity photo dump like it’s breaking news.
          </p>
          <p className="m-0 leading-relaxed text-copy">
            Whether you’re here for shopping recommendations, trend forecasting, beauty products, travel guides, or
            simply because you love keeping up with what’s happening, TIGG exists to keep you in the know. Think of
            it as your stylish friend who always has a recommendation, a strong opinion, and approximately
            forty-seven tabs open. So grab a coffee, stay awhile, and make yourself at home.
          </p>
          <p className="m-0 leading-relaxed text-copy">Love,</p>
          <img
            src={asset('2022/01/Layer-6.png')}
            alt="Sky Haarsma signature"
            className="w-[140px] object-contain"
          />
        </div>

        <aside data-reveal className="grid grid-cols-2 gap-2.5">
          {[
            '2022/01/sky-haarsma-1-1.jpg',
            '2022/01/sky-haarsma-2-1.jpg',
            '2022/01/Layer-5.jpg',
            '2022/01/sky-haarsma-3.jpg',
          ].map((image) => (
            <img
              key={image}
              src={asset(image)}
              alt="Sky Haarsma"
              className="aspect-[4/5] w-full object-cover object-top bg-sand"
            />
          ))}
          {instagram ? (
            <a
              href={instagram}
              target="_blank"
              rel="noreferrer"
              className="text-caps col-span-2 mt-1 text-rose hover:text-ink"
            >
              {instagramLabel}
            </a>
          ) : null}
        </aside>
      </section>
    </main>
  )
}
